// extracted by mini-css-extract-plugin
export var fadeIn = "_go-1";
export var modalContent = "_go-3";
export var overlay = "_go-0";
export var popoverContent = "_go-2";
export var results = "_go-5";
export var searchInputWrapper = "_go-4";